/**
 * Tool Policy Resolver - Enforces tool allow/deny policies
 */

import type { ToolPolicy } from "./types.js";

/** Tool definition */
export interface Tool {
	name: string;
	group?: string;
	description: string;
}

/** Tool policy resolver */
export class ToolPolicyResolver {
	private policy: ToolPolicy;

	constructor(policy: ToolPolicy = {}) {
		this.policy = policy;
	}

	/**
	 * Check if tool is allowed
	 */
	isAllowed(tool: Tool): boolean {
		// Check deny list first
		if (this.policy.deny?.includes(tool.name)) {
			return false;
		}

		// Check deny groups
		if (tool.group && this.policy.denyGroups?.includes(tool.group)) {
			return false;
		}

		// Check allow list
		if (this.policy.allow) {
			return this.policy.allow.includes(tool.name);
		}

		// Check allow groups
		if (tool.group && this.policy.allowGroups) {
			return this.policy.allowGroups.includes(tool.group);
		}

		// Default allow
		return true;
	}

	/**
	 * Filter tools by policy
	 */
	filterTools(tools: Tool[]): Tool[] {
		return tools.filter((tool) => this.isAllowed(tool));
	}

	/**
	 * Get allowed tool names
	 */
	getAllowedTools(allTools: Tool[]): string[] {
		return this.filterTools(allTools).map((t) => t.name);
	}
}
